export default "__VITE_ASSET__C_y_2_zh__"